import { render, staticRenderFns } from "./UserOrgAdd.vue?vue&type=template&id=19a2c12d&scoped=true"
import script from "./UserOrgAdd.vue?vue&type=script&lang=js"
export * from "./UserOrgAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2c12d",
  null
  
)

export default component.exports